"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupType = void 0;
var GroupType;
(function (GroupType) {
    GroupType["PATIENT"] = "patient";
    GroupType["CAREGIVER"] = "caregiver";
    GroupType["ADMIN"] = "admin";
})(GroupType = exports.GroupType || (exports.GroupType = {}));
